import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBz0UAqWKgmGMXBNzhYF7p3HNZ92GiJFNQ",
  authDomain: "awesome-radi-languages.firebaseapp.com",
  databaseURL: "https://awesome-radi-languages.firebaseio.com",
  projectId: "awesome-radi-languages",
  storageBucket: "awesome-radi-languages.appspot.com",
  messagingSenderId: "431747877711",
  appId: "1:431747877711:web:017950961975935e7c533a",
  measurementId: "G-CL49YSF216",
};

firebase.initializeApp(firebaseConfig);

const database = firebase.database();
const storage = firebase.storage();
const dbFirestore = firebase.firestore();

export { database, firebase, storage, dbFirestore };
